<template>
	<!-- 倒數計時器本體 -->
	<div class="count_timer_container"  :style="{
                backgroundImage: background_color
        }">
		<div class="count_timer" v-show="is_show">
			<article class="count_timer_header">
				<h2
					id="t_description"
					class="description"
                    :style="{
                        fontSize: campaign_text.size + 'px',
                        color: campaign_text.color
                    }"
				>
					{{campaign_text.text}}
				</h2>
			</article>
			<article class="count_timer_body">

				<div class="units_container">
					<div id="t_days" class="number"
                        :style="{
                            backgroundImage: number_color,
                            fontSize: number_size + 'px'
                        }"
                    >
						00
					</div>
					<div id="t_days_unit" class="unit" 
                        :style="{
                            fontSize: unit.size,
                            color: unit.color
                        }"
                    >
						天
					</div>
				</div>

				<div class="symbol_container"
                    :style="{
                        marginLeft: symbol.letter_spacing + 'px',
                        marginRight: symbol.letter_spacing + 'px',
                    }"
                >
					<span class="symbol"
                        :style="{
                            fontSize: symbol.size + 'px',
                            color: symbol.color,
                            top: symbol.top + 'px'
                        }"
                    >:</span>
				</div>

				<div class="units_container">
					<div id="t_hours" class="number"
                        :style="{
                            backgroundImage: number_color,
                            fontSize: number_size + 'px'
                        }"
                    >
						00
					</div>
					<div id="t_hours_unit" class="unit"
                        :style="{
                            fontSize: unit.size,
                            color: unit.color
                        }"
                    >
						時
					</div>
				</div>	

				<div class="symbol_container"
                    :style="{
                        marginLeft: symbol.letter_spacing + 'px',
                        marginRight: symbol.letter_spacing + 'px',
                    }"
                >
					<span class="symbol"
                        :style="{
                            fontSize: symbol.size + 'px',
                            color: symbol.color,
                            top: symbol.top + 'px'
                        }"
                    >:</span>
				</div>

				<div class="units_container">
					<div id="t_minutes" class="number"
                        :style="{
                            backgroundImage: number_color,
                            fontSize: number_size + 'px'
                        }"
                    >
						00
					</div>
					<div id="t_minutes_unit" class="unit"
                        :style="{
                            fontSize: unit.size,
                            color: unit.color
                        }"
                    >
						分
					</div>
				</div>

				<div class="symbol_container"
                    :style="{
                        marginLeft: symbol.letter_spacing + 'px',
                        marginRight: symbol.letter_spacing + 'px',
                    }"
                >
					<span class="symbol"
                        :style="{
                            fontSize: symbol.size + 'px',
                            color: symbol.color,
                            top: symbol.top + 'px'
                        }"
                    >:</span>
				</div>	
				
				<div class="units_container">
					<div id="t_seconds" class="number sec"
                        :style="{
                            backgroundImage: number_color,
                            fontSize: number_size + 'px'
                        }"
                    >
						00
					</div>
					<div id="t_seconds_unit" class="unit"
                        :style="{
                            fontSize: unit.size,
                            color: unit.color
                        }"
                    >
						秒
					</div>
				</div>														
			</article>
		</div>
	</div>
</template>

<script>

	// api
	import {
		apiGetSettingByIdPulic
	} from '@/api/iframe.js'

	export default {
		name: 'TimerPubicIFrame',
		components: {

		}, 		
		data: function() {
			return {
				config: {

					// 設定檔名稱
					name: "",

					// 開始時間
					start_at: new Date(),

					// 結束時間
					end_at: new Date(new Date().setDate(new Date().getDate() + 1)),

					// 活動開始時間
					campaign_start_at: "",

					// 活動結束時間
					campaign_end_at: "",

					// iframe height
					iframe_height: 200,

					selected_setting: {
							tab_name: "活動開始前",
							type: "warm_up",
							background_1:{
								color: "",
								menu: false
							},
							background_2:{
								color: "",
								menu: false
							},
					},
					selected_setting_tab_name: '活動開始前',

					settings: [
						{
							tab_name: "活動開始前",
							type: "warm_up",
							background_1:{
								color: "#A8ADBB",
								menu: false
							},
							background_2:{
								color: "#856667",
								menu: false
							},
							campaign_text: {
								text: "活動開始前",
								size: '20',
								color: '#FFFFFF',
								menu: false
							},
						},
						{
							tab_name: "活動進行中",
							type: "campaign",
							background_1:{
								color: "#A90F1D",
								menu: false
							},
							background_2:{
								color: "#A90F1D",
								menu: false
							},
							campaign_text: {
								text: "活動進行中",
								size: '20',
								color: '#FFFFFF',
								menu: false
							},
							time_size: 36,
							time_1: {
								color: "#F1F3A5",
								menu: false
							},
							time_2: {
								color: "#FFCB70",
								menu: false
							},
							unit: {
								size: 16,
								color: '#FFFFFF',
								menu: false,
							},
							symbol: {
								size: 26,
								color: '#FFFFFF',
								top: 5,
								letter_spacing: 8,
								menu: false,
							}
						},
						{
							tab_name: "活動結束後",
							type: "over",
							background_1:{
								color: "#334163",
								menu: false
							},
							background_2:{
								color: "#724448",
								menu: false
							},
							campaign_text: {
								text: "活動結束後",
								size: '20',
								color: '#FFFFFF',
								menu: false
							},
							time_size: 36,
							time_1: {
								color: "#F1F3A5",
								menu: false
							},
							time_2: {
								color: "#FFCB70",
								menu: false
							},
							unit: {
								size: 16,
								color: '#FFFFFF',
								menu: false,
							},
							symbol: {
								size: 26,
								color: '#FFFFFF',
								top: 5,
								letter_spacing: 8,
								menu: false,
							}
						},
					],

					advanced_config: {
						repeat_day: 0,
					},
					preview_at: null,

					add_column: {
						timer_style: {

							time_size: 36,

							time_1: {
								color: "#F1F3A5",
								menu: false
							},
							time_2: {
								color: "#FFCB70",
								menu: false
							},
							unit: {
								size: 16,
								color: '#FFFFFF',
								menu: false,
							},
							symbol: {
								size: 26,
								color: '#FFFFFF',
								top: 3,
								letter_spacing: 8,
								menu: false,
							}
						},
					},

					error_message: {
						name:'',
						start_at: '',
						end_at: '',
						campaign_start_at: '',
						campaign_end_at: '',
						preview: '',
					}
				},

                background_color: '',
                number_color: '',
                number_size: '',
                unit:{},
                campaign_text: {},
                symbol: {},
                countdown_timer: null,

                is_show: false
			}
		},
		created: async function(){
			// 先判斷是新還是舊 
			// 如果是舊就讀設定檔
			console.log('這裡')
			console.log(this.$route)
			console.log('這裡')

            if (!this.$route.query.id) {
                return
            }
            console.log('id:', this.$route.query.id)
            let id = this.$route.query.id

			// 讀舊檔 start_at/end_at超過後端什麼都不會回
            // 所以會直接空白
            let config = await this.loadData(id)
            console.log('config', config)
            if (Object.keys(config).length === 0) {
                return
            }

            // 代表start_at / end_at還沒過，需要顯示樣式
            // 那我要開始啦
            this.config.name = config.name
            this.config.start_at = new Date(config.start_at.replace(' ', 'T'))
            this.config.end_at = new Date(config.end_at.replace(' ', 'T'))
            this.config.campaign_start_at = new Date(config.campaign_start_at.replace(' ', 'T'))
            this.config.campaign_end_at = new Date(config.campaign_end_at.replace(' ', 'T'))
            this.config.iframe_height = config.iframe_height
            this.config.settings = JSON.parse(config.settings)
            this.config.add_column = JSON.parse(config.add_column)


            this.initTimer(this.config)
            let that = this
            setTimeout(function(){
                that.is_show = true
            },1000)
            
		},
		mounted: function(){
			let html_ele = window.document.querySelector('html')
			html_ele.style.overflowY = 'hidden'
		},
        destroyed: function(){
            this.clearTimer()
        },
		methods: {
			loadData: async function(id) {
				let data = null
				let that = this
				data = await apiGetSettingByIdPulic(
					id
				).then(function(resp){
					return resp.data.data
				}).catch(function(error){
					that.$root.vtoast.show({ message: "取得舊檔失敗，原因: " + (error.response ? error.response : error) }) 
					return null
				})

				return data
			},
            initTimer: function(config){
                // 檢查當下時間是哪種類型
                let type = ''
                let now = new Date().getTime()
                let start_at = new Date(config.start_at).getTime()
                let end_at = new Date(config.end_at).getTime()
                let campaign_start_at = new Date(config.campaign_start_at).getTime()
                let campaign_end_at = new Date(config.campaign_end_at).getTime()

                console.log(now)
                console.log(start_at)
                console.log(end_at)
                console.log(campaign_start_at)
                console.log(campaign_end_at)

                if (now >= start_at && now <= campaign_start_at) {
                    type = 'warm_up'
                }
                else if(now >= campaign_start_at && now <= campaign_end_at) {
                    type = 'campaign'
                }
                else if(now >= campaign_end_at && now <= end_at){
                    type = 'over'
                }

				if (config.add_column.repeat_day && type === 'over') {
					type = 'campaign'
				}

                console.log(type)
                
                let target_setting = this.config.settings.filter(function(setting){
                    return setting.type === type
                })

                target_setting = target_setting[0]

                console.log(target_setting)

                // 背景顏色
                this.background_color = 'linear-gradient(62deg,' + target_setting.background_1.color  + ' 0%, ' + target_setting.background_2.color  + ' 100%)'
                
                // 數字的顏色
                this.number_color = 'linear-gradient(62deg,' + this.config.add_column.timer_style.time_1.color  + ' 0%, ' + this.config.add_column.timer_style.time_2.color + ' 100%)'
                
                // 數字大小
                this.number_size = this.config.add_column.timer_style.time_size

                // 活動文字顏色大小
                this.campaign_text = target_setting.campaign_text

                // 單位顏色大小
                this.unit = this.config.add_column.timer_style.unit

                this.symbol = this.config.add_column.timer_style.symbol 
                console.log('this.symbol_spacing',this.symbol_spacing)

                let distance = null
                let that = this
                // 換數字
                switch (type) {
                    case 'warm_up':
                        distance = campaign_start_at - now
							this.countdown_timer = setInterval(function() {
								distance = distance - 1000
								if (distance < 0){
									clearInterval(that.countdown_timer);
									document.getElementById("t_days").innerText = '00'
									document.getElementById("t_hours").innerText = '00'
									document.getElementById("t_minutes").innerText = '00'						
									document.getElementById("t_seconds").innerText = '00'			
									return
								}

								let show_units = that.getCountDownUnit(distance)
								//console.log(show_units)
								let units = Object.keys(show_units)
								units.forEach(function(unit){
									document.getElementById(unit).innerText = show_units[unit]
								})

							}, 1000);

							// var unit = this.getCountDownUnit(distance)
							// document.getElementById("t_days").innerText = unit.t_days
							// document.getElementById("t_hours").innerText = unit.t_hours
							// document.getElementById("t_minutes").innerText = unit.t_minutes				
							// document.getElementById("t_seconds").innerText = unit.t_seconds
                        break;
                    case 'campaign':
                        distance = campaign_end_at - now;
						if (distance <= 0) {
							let repeat_day_second = parseInt(config.add_column.repeat_day) *  24 * 60 * 60 * 1000
							let lost_duration = 0
							if (new Date().getTime() - campaign_end_at < repeat_day_second) {
								console.log('進1')
								lost_duration = repeat_day_second - (new Date().getTime() - campaign_end_at)  
							}
							else {
								console.log('進2')
								lost_duration = repeat_day_second - (new Date().getTime() - campaign_end_at )% repeat_day_second
							}

							distance = lost_duration
						}

                        this.countdown_timer = setInterval(function() {
                            distance = distance - 1000
                            if (distance < 0){
                                clearInterval(that.countdown_timer);
                                document.getElementById("t_days").innerText = '00'
                                document.getElementById("t_hours").innerText = '00'
                                document.getElementById("t_minutes").innerText = '00'						
                                document.getElementById("t_seconds").innerText = '00'			
                                return
                            }

                            let show_units = that.getCountDownUnit(distance)
                            //console.log(show_units)
                            let units = Object.keys(show_units)
                            units.forEach(function(unit){
                                document.getElementById(unit).innerText = show_units[unit]
                            })

                        }, 1000);
                        break
                    case 'over':
                        document.getElementById("t_days").innerText = '00'
                        document.getElementById("t_hours").innerText = '00'
                        document.getElementById("t_minutes").innerText = '00'					
                        document.getElementById("t_seconds").innerText = '00'
                        break
                }


            },
            getCountDownUnit: function(distance) {
                var days = Math.floor(distance / (1000 * 60 * 60 * 24));
                var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                var seconds = Math.floor((distance % (1000 * 60)) / 1000);
                days = days.toString()
                if (days.length === 1) {
                    days = '0' + days
                }
                hours = hours.toString()
                if (hours.length === 1) {
                    hours = '0' + hours
                }				
                minutes = minutes.toString()
                if (minutes.length === 1) {
                    minutes = '0' + minutes
                }	
                seconds = seconds.toString()
                if (seconds.length === 1) {
                    seconds = '0' + seconds
                }	
                
                let result = {
                    t_days: days,
                    t_hours: hours,
                    t_minutes: minutes,
                    t_seconds: seconds
                }
                return result
            },
            clearTimer: function(){
                clearInterval(this.countdown_timer)
            },			
		},		
		computed: {
		},
	}
</script>
<style scoped>
.count_timer_container {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	background-color:#FFF;
	width: 100%;
    height: 100%;
}
.count_timer {
	display: flex;
	flex-direction: column;
	justify-content: center;
	margin: 1em 0px;
}
.count_timer_header {
	text-align: center;
	font-size: 12px;
}
.description {
	font-weight: bold;
	/* -webkit-background-clip: text;
	-moz-background-clip: text;
	-webkit-text-fill-color: transparent;
	-moz-text-fill-color: transparent;	 */
}
.count_timer_body {
	display: flex;
	flex-direction: row;
	justify-content: center;
    line-height: 1 !important;
}
.count_timer_header , .count_timer_body {
	margin: 1em 0px;
}
.count_timer_header {
	margin-bottom: 0em
}
.count_timer_body  {
	margin-top: 0.5em;
}
.units_container {
	display: flex;
	flex-direction: column;
	justify-content: center;
}
.symbol_container {
	margin: 0px 5px;
}
.units_container > div {
	text-align: center;
}
.number {
	font-size: 28px;
	font-weight: bold;
	-webkit-background-clip: text;
	-moz-background-clip: text;
	-webkit-text-fill-color: transparent;
	-moz-text-fill-color: transparent;	
	background-color: #000;	
}
.unit {
	font-size: 18px;	
}
.symbol {
	position: relative;
	font-size: 27px;
	/* -webkit-background-clip: text;
	-moz-background-clip: text;
	-webkit-text-fill-color: transparent;
	-moz-text-fill-color: transparent;
	background-color: #000;			 */
}
.sec {
	color: red;
}
.emoji {
	-webkit-text-fill-color: initial;
}
.card-subtitle {
    padding-left: 0px !important;
}
</style>